module.exports = {
	"de": {
		"titel": "Die Halle der Runen-Karten"
	},
	"en": {
		"titel": "Buy"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/runeset-shop-view/locales.json
// module id = 67
// module chunks = 0